import { ItemType, SectionCreatedEvent, SectionType } from '@ankorstore/events-tracking';
import Analytics from '@client/monolith/legacy/services/analytics';
import UserClick from '@client/monolith/legacy/services/analytics/events/user-click.event';

export const useTracking = () => {
  const productsTracking = (products) => {
    return products.map((product, index) => ({
      position: index,
      id: Number(product.id),
      name: product.attributes.name,
    }));
  };

  const trackBrandHighlightedClick = (brandSneakPeek, carouselUuid) => {
    Analytics.track(
      new UserClick({
        component: SectionType.RECO_CAROUSEL,
        id_brand: brandSneakPeek.id,
        value_proposition: carouselUuid,
        itemType: 'product',
        action: 'click_highlighted_brand',
      })
    );
  };

  const trackInstagramLinkClick = (brandSneakPeek, carouselUuid) => {
    Analytics.track(
      new UserClick({
        component: SectionType.RECO_CAROUSEL,
        id_brand: brandSneakPeek.id,
        value_proposition: carouselUuid,
        itemType: 'product',
        action: 'click_instagram_link',
      })
    );
  };

  const trackProductClick = ({ product, index }, carouselUuid) => {
    Analytics.track(
      new UserClick({
        component: SectionType.RECO_CAROUSEL,
        id_product: product.id,
        value_proposition: carouselUuid,
        itemType: 'product',
        position: index,
        action: 'click_product',
      })
    );
  };

  const trackNewPageClick = (carouselUuid) => {
    Analytics.track(
      new UserClick({
        component: SectionType.RECO_CAROUSEL,
        value_proposition: carouselUuid,
        itemType: 'button',
        action: 'click_discover_new_brands',
      })
    );
  };

  const trackSectionCreated = (products, carouselUuid) => {
    const payload = {
      id_product: productsTracking(products),
    };
    const nbTiles = products.length;
    Analytics.track(
      SectionCreatedEvent({
        section_type: SectionType.RECO_CAROUSEL,
        value_proposition: carouselUuid,
        itemType: ItemType.PRODUCT,
        nb_tiles: nbTiles,
        ...payload,
      })
    );
  };
  return {
    trackSectionCreated,
    trackProductClick,
    productsTracking,
    trackBrandHighlightedClick,
    trackNewPageClick,
    trackInstagramLinkClick,
  };
};
